define(["data/config"], function(config) {
    var $window = $(window);

    var create = function(params) {
        if (typeof params.persist === "undefined") {
            params.persist = false;
        }
        if (typeof params.wrap === "undefined") {
            params.wrap = true;
        }
        if (typeof params.position === "undefined") {
            var offset = params.origin.offset().top - $window.scrollTop();
            params.position =
                offset > $window.height() / 1.5 ? "top" : "bottom";
        }
        if (typeof params.html === "string") {
            params.html = $("<span>" + params.html + "<span>");
        }

        if (params.wrap) {
            params.html = params.html
                .wrap('<div class="c_popover-wrap"></div>')
                .parent();
        }

        var $popover = $("<div></div>")
            .html(params.html)
            .addClass(
                "c_popover c_popover--in c_popover--position" +
                    params.position.capitalizeFirstLetter()
            )
            .css({ visibility: "hidden" })
            .data("origin", params.origin);

        $popover.on(config.events.popoverRequestClose, function() {
            $(".c_popoverMask").remove();
            $popover.addClass("c_popover--out");
            params.origin.removeClass("js_tooltip--popped");
            setTimeout(function() {
                $popover.detach();
                params.origin.data("popoverActive", false);
            }, 500);
            setTimeout(function() {
                $popover.remove();
            }, 240000);
            /* detach first to keep events from inside hanging around for a while (especially for trigger/moderatorCompanyAdd).
            TODO: make this an option and let the firer handle whether to remove and detach + eventually fire a remove event to prevent memory leaks */
            $(document).unbind(".popoverCloser");
        });

        $popover.on("click touchstart", ".c_popover-menu-item", function() {
            $popover.trigger(config.events.popoverRequestClose);
        });

        if (params.style) {
            $popover.addClass(
                "c_popover--style" + params.style.capitalizeFirstLetter()
            );
        }

        $popover.params = params;

        return $popover;
    };

    var placePopover = function($popover) {
        var pos = {};
        var $origin = $popover.params.origin;

        if ($popover.getCssContent().tooltipDisplay === "panel") {
            var $mask = $('<div class="c_popoverMask"></div>');
            $mask.on("click", function() {
                $popover.trigger(config.events.popoverRequestClose);
            });
            $("body").append($mask);
            $popover.css({ visibility: "visible" });
        } else {
            if ($popover.params.position === "top") {
                pos = {
                    left:
                        $origin.offset().left -
                        $popover.outerWidth() / 2 +
                        $origin.outerWidth() / 2,
                    top: $origin.offset().top - $popover.outerHeight() - 15
                };
            } else {
                pos = {
                    left:
                        $origin.offset().left -
                        $popover.outerWidth() / 2 +
                        $origin.outerWidth() / 2,
                    top: $origin.offset().top + $origin.outerHeight() + 10
                };
            }

            if ($popover.params.fixed) {
                pos.position = "fixed";
                pos.top = pos.top - $window.scrollTop();
            }

            if (pos.left + $popover.outerWidth() - $window.width() > -50) {
                pos.left = pos.left - $popover.outerWidth() / 2 + 20;
                $popover.addClass("c_popover--beakRight");
            }
            if (pos.left < 50) {
                pos.left = pos.left + $popover.outerWidth() / 2 - 20;
                $popover.addClass("c_popover--beakLeft");
            }

            $popover.css(pos).css({ visibility: "visible" });
            $popover.params.origin.addClass("js_tooltip--popped");
        }
    };

    var calculateDistance = function(elem, mouseX, mouseY) {
        return Math.floor(
            Math.sqrt(
                Math.pow(mouseX - (elem.offset().left + elem.width() / 2), 2) +
                    Math.pow(
                        mouseY - (elem.offset().top + elem.height() / 2),
                        2
                    )
            )
        );
    };

    var Popover = function(params) {
        if (params.ajax) {
            params.url = params.ajax;
        }

        if (params.html) {
            var content = params.html;
        } else {
            var content = params.origin.findTarget(params.target).html()
                ? params.origin.findTarget(params.target).html()
                : "loading…";
        }

        var $popover = create({
            url: params.url,
            html: content,
            position: params.position,
            style: params.style,
            origin: params.origin,
            wrap: params.wrap,
            persist: params.persist,
            fixed: params.fixed
        });

        if ($popover.params.url) {
            $.get(params.url).done(function(data) {
                $popover.html(data);
                $(window).trigger(config.events.significantDomChange);
                $(window).trigger(
                    config.events.routerRouteLoaded,
                    $popover.params.url
                );
            });
        }

        params.origin.on(config.events.popoverRequestClose, function() {
            params.popover.trigger(config.events.popoverRequestClose);
        });

        this.place = function() {
            if (params.origin.data("popoverActive") === true) return;
            params.origin.data("popoverActive", true);

            $("body").append($popover);
            placePopover($popover);
            $window.trigger(config.events.significantDomChange);
            $popover.trigger(config.events.popoverOnLoad);
            var mouseOrigin = 0;
            if (
                (!params.persist || params.persist === false) &&
                $popover.getCssContent().tooltipDisplay !== "panel"
            ) {
                $(document).on("mousemove.popoverCloser", function(ev) {
                    var distance = calculateDistance(
                        $popover,
                        ev.pageX,
                        ev.pageY
                    );
                    distance = Math.round(distance / 5);
                    if (mouseOrigin === 0) {
                        mouseOrigin = distance;
                    } else {
                        if (
                            mouseOrigin - distance < -4 &&
                            !$popover.is($(ev.target)) &&
                            !$popover.has($(ev.target)).length > 0
                        ) {
                            $popover.trigger(config.events.popoverRequestClose);
                        }
                    }
                });
                $popover.on("mouseleave.popoverCloser", function(ev) {
                    $popover.trigger(config.events.popoverRequestClose);
                });
            } else {
                $(document).on("click", function(ev) {
                    $popover.trigger(config.events.popoverRequestClose);
                });
            }
        };

        this.on = function(ev, callback) {
            return $popover.on(ev, callback);
        };

        this.trigger = function(ev, params) {
            return $popover.trigger(ev, params);
        };

        this.find = function(el) {
            return $popover.find(el);
        };

        this._clearAllPopovers = function() {
            $(".c_popover").trigger(config.events.popoverRequestClose);
        };

        return this;
    };

    return Popover;
});
